import { UiElement } from "../../ui/UiElement.js";

/**
 * A function that creates an element for the basic ProjectDescription
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function ProjectInfo(options, viewer) {
    const element = new UiElement();

    let html = "";
    if (options.title) html += "<h3>" + options.title + "</h3>";
    if (options.description) html += "<p>" + options.description + "</p>";
    if (Array.isArray(options.keywords) && (options.keywords.length > 0)) html += "<h3>Keywords</h3><p>" + options.keywords.join(", ") + "</p>";
    if (options.references) html += "<h3>References</h3><p>" + options.references + "</p>";

    element.getElement().innerHTML = html;
    viewer.addElement(options.id, element);
}